import { FileWithPath } from "@mantine/dropzone"
import { useMutation, UseMutationOptions } from "@tanstack/react-query"
import { AxiosError } from "axios"

import { httpClient } from "~/backend/axios"

type BlankProductImportVerifyRequest = {
  file: FileWithPath
  clientUserEmail: string
}

export const useVerifyBlankProductImportMutation = (
  options?: UseMutationOptions<
    boolean,
    AxiosError,
    BlankProductImportVerifyRequest
  >
) =>
  useMutation({
    mutationFn: async ({
      file,
      clientUserEmail,
    }: BlankProductImportVerifyRequest) => {
      const formData = new FormData()
      formData.set("file", file)
      formData.set("clientUserEmail", clientUserEmail)

      const response = await httpClient.post(
        "/v1/product/verify-blank-import",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      )
      return response.data
    },

    ...options,
  })
